import { Delete, Get, getAPIUrl, Post } from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const BlogEndpoint = {
  getContent: `/admin/content/list`,
  getContentbyId: `/admin/content/details/`,
  deleteContent: ``,
  editContent: `/admin/content/update`,
  uploadImage: `/admin/content/uploadImage`,
};

export const getContent = (param = "") => {
  const url = getAPIUrl(BlogEndpoint.getContent, param);
  return Get(HomePageService, url, true);
};
export const getContentbyId = (param = "") => {
  const url = getAPIUrl(BlogEndpoint.getContentbyId, param);
  return Get(HomePageService, url, true);
};
export const editContent = (data, param = "") => {
  const url = getAPIUrl(BlogEndpoint.editContent, param);
  return Post(HomePageService, url, data, true);
};

export const uploadImage = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    if (data[k]) {
      formData.append(k, data[k]);
    }
  });
  const url = getAPIUrl(BlogEndpoint.uploadImage);
  return Post(HomePageService, url, formData, true, true);
};
export const deleteContent = (param = "") => {
  const url = getAPIUrl(BlogEndpoint.deleteContent, param);
  return Delete(HomePageService, url, param);
};
